/**
 * Class Name Utility
 * Combines clsx and tailwind-merge for optimal class merging
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names with Tailwind CSS conflict resolution
 *
 * @example
 * cn('px-2 py-1', 'px-4') // => 'py-1 px-4'
 * cn('text-red-500', condition && 'text-blue-500')
 * cn(['base', 'classes'], { conditional: true })
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
